import React, {useEffect, useMemo, useState} from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import WithOverlay from "../withOverlayHoc";
import WizardConflictPopupSQFTButtons from "./wizardConflictPopupSQFTButtons";
import ReviewConflicts from "./steps/ReviewConflicts";
import SQFTWindow from "./steps/SQFTWindow";
import {STEP_TITLES, STEPS} from "./steps/registry";

const WizardConflictPopupSQFT = (props) => {
  const { cartItems, sqftCartItems, wizardConflictingSteps } = props;
  const [step, setStep] = useState(STEPS.REVIEW);

  useEffect(() => {
    return () => {
      setStep(STEPS.REVIEW);
    }
  }, [])

  const cartItemsToChange = useMemo(
    () => {
      const cartItemsAndSQFTTempCartItems = [...sqftCartItems, ...cartItems];
      let cartItemsToChange = cartItemsAndSQFTTempCartItems.filter(ci => wizardConflictingSteps?.some(c => c.cartItemId === ci.id))
      cartItemsToChange = cartItemsToChange.sort((a, b) => {
        const stepA = wizardConflictingSteps?.find(conf => conf.cartItemId === a.id)?.stepIndex ?? 0;
        const stepB = wizardConflictingSteps?.find(conf => conf.cartItemId === b.id)?.stepIndex ?? 0;
        return stepA - stepB;
      });
      return cartItemsToChange
    },
    [cartItems, sqftCartItems, wizardConflictingSteps]
  );

  if (!cartItemsToChange || !cartItemsToChange.length) {
    return null
  }

  const incompatibleFeatureName = cartItemsToChange[0]?.cartFeature?.getFeatureName();

  return (
    <WithOverlay className="overlay--confirm">
      {(hideOverlay) => {
        const titleId = STEP_TITLES[step];

        return (
          <div className={"ui-popup conflict-popup" + (step === STEPS.FIX ? " conflict-popup--lg " : "")}>
            <div className="ui-popup__header conflict-popup__header">
              <div className="gc-disclaimer__icon" />
              <span className="conflict-popup__header-title">
                <FormattedMessage id={titleId} values={{ incompatibleFeatureName }}/>
              </span>
            </div>

            <div className="ui-popup__body">
              <div className="ui-popup__body-content ui-popup__body-content--full">
                {step === STEPS.REVIEW ? (
                  <ReviewConflicts cartItems={cartItemsToChange} />
                ) : (
                  <SQFTWindow cartItemsToChange={cartItemsToChange} conflicts={wizardConflictingSteps} />
                )}
              </div>
            </div>

            <WizardConflictPopupSQFTButtons
              step={step}
              setStep={setStep}
              hideOverlay={hideOverlay}
            />
          </div>
        );
      }}
    </WithOverlay>
  );
};

const mapStateToProps = (store) => {
  const { wizardConflictingSteps, wizardConflictPopupOpened } = store.wizardState;
  const { cartItems } = store.cartState;
  const { sqftCartItems } = store.sqftResourceState;
  return {
    cartItems,
    wizardConflictingSteps,
    wizardConflictPopupOpened,
    sqftCartItems,
  };
};

export default connect(mapStateToProps)(WizardConflictPopupSQFT);
